import React from "react";
import { PaymentRequestButtonElement } from "react-stripe-elements";

class PaymentRequestForm extends React.Component {
  render() {
    return this.props.canMakePayment ? (
      <PaymentRequestButtonElement
        paymentRequest={this.props.paymentRequest}
        className={`payment-request-btn ${this.props.isDisabled ? "loading-content" : ""}`}
        style={{
          paymentRequestButton: {
            type: "donate",
            theme: "dark",
            height: "58px",
          },
        }}
      />
    ) : null;
  }
}
export default PaymentRequestForm;
